export const LANDING_COPY = {
  en: {
    nav: { pricing: "Pricing", demo: "Live Demo", loading: "Loading…", signin: "Sign in" },
    hero: {
      kicker: "Your AI Sports Companion",
      headA: "Smarter than",
      headB: "the broadcast",
      sub1: "Understand every play.",
      sub2: "Never watch a game alone.",
      desc: "Gamly watches the game with you — explaining every play, tracking every win-probability swing and answering any question in real time. Plus a Press Box Assistant for broadcasters, reporters and podcasters.",
      demo: "Try the Live Demo",
      demoLoading: "Loading demo…",
      google: "Sign in with Google",
      pricing: "See pricing",
      tags: ["NBA", "NFL", "MLB", "UFC", "Soccer", "Fantasy", "Sports Cards", "EN / ES / Bilingual"],
    },
    why: { kicker: "Why an AI Sports Companion", title: "The broadcast shows the game. Gamly shows you what it means." },
    stories: { kicker: "How fans use it", title: "Every game, a better seat", cta: "Watch a game with Gamly" },
    features: {
      kicker: "Everything in the companion",
      title: "Built for fans who watch differently",
      items: [
        { title: "Live Game Companion", desc: "Score, win prob, key matchup, AI 'Why It Matters' on every game." },
        { title: "Ask Gamly AI", desc: "Real-time, broadcaster-style answers to anything sports." },
        { title: "Storylines Feed", desc: "Rivalries, rookie breakouts, playoff math — generated for you." },
        { title: "Card Watchlist", desc: "Track purchase price vs estimated value with photos." },
        { title: "Player Watchlist", desc: "Real-time stat lines and storylines on the players you love." },
        { title: "8 AI Modes", desc: "Why It Matters · Hot Take · Fantasy Impact · Card Market · and more." },
      ],
    },
    press: {
      kicker: "Press Box Pro · $299/mo",
      title: "For broadcasters, reporters, and podcasters",
      desc: "Run a live broadcast with Gamly feeding production-ready talking points, stat packs, interview questions, and on-air scripts — in English or Spanish, beat-by-beat.",
      items: [
        { title: "Press Box Mode", desc: "8 production-ready talking-point cards per live game. Auto-refresh during the broadcast." },
        { title: "Interview Assistant", desc: "Player + coach question packs in EN, ES, or Bilingual." },
        { title: "Commentary Assistant", desc: "Opening / halftime / closing scripts in TV or radio style." },
      ],
      cta: "See Press Box Mode in action",
    },
    wim: {
      a: "Tap",
      b: "Why It Matters",
      c: "on any game",
      desc: "Instant playoff math, fantasy stakes, card market ripple effects, and the one thing you should watch next.",
      cta: "Start free",
    },
    footer: "© 2026 Gamly AI — AI Sports Companion + Press Box Assistant.",
  },
  es: {
    nav: { pricing: "Precios", demo: "Demo en vivo", loading: "Cargando…", signin: "Iniciar sesión" },
    hero: {
      kicker: "Tu compañero deportivo con IA",
      headA: "Más inteligente que",
      headB: "la transmisión",
      sub1: "Entiende cada jugada.",
      sub2: "Nunca veas un partido solo.",
      desc: "Gamly ve el partido contigo: explica cada jugada, sigue cada cambio en la probabilidad de victoria y responde cualquier pregunta en tiempo real. Además, un asistente de Press Box para narradores, reporteros y podcasters.",
      demo: "Prueba la demo en vivo",
      demoLoading: "Cargando demo…",
      google: "Entra con Google",
      pricing: "Ver precios",
      tags: ["NBA", "NFL", "MLB", "UFC", "Fútbol", "Fantasy", "Tarjetas deportivas", "EN / ES / Bilingüe"],
    },
    why: { kicker: "Por qué un compañero deportivo con IA", title: "La transmisión te muestra el partido. Gamly te muestra lo que significa." },
    stories: { kicker: "Cómo lo usan los fans", title: "Cada partido, un mejor asiento", cta: "Ve un partido con Gamly" },
    features: {
      kicker: "Todo lo que incluye el compañero",
      title: "Hecho para fans que ven el deporte diferente",
      items: [
        { title: "Compañero en vivo", desc: "Marcador, probabilidad de victoria, duelo clave y 'Por qué importa' con IA en cada partido." },
        { title: "Pregúntale a Gamly", desc: "Respuestas al instante, con estilo de narrador, sobre cualquier tema deportivo." },
        { title: "Historias del día", desc: "Rivalidades, novatos que despegan, cuentas para playoffs — generadas para ti." },
        { title: "Seguimiento de tarjetas", desc: "Compara el precio de compra con el valor estimado, con fotos." },
        { title: "Jugadores favoritos", desc: "Estadísticas en tiempo real e historias de los jugadores que más sigues." },
        { title: "8 modos de IA", desc: "Por qué importa · Opinión picante · Impacto fantasy · Mercado de tarjetas · y más." },
      ],
    },
    press: {
      kicker: "Press Box Pro · $299/mes",
      title: "Para narradores, reporteros y podcasters",
      desc: "Haz tu transmisión en vivo con Gamly entregándote puntos de conversación listos para el aire, paquetes de estadísticas, preguntas para entrevistas y guiones — en inglés o español, jugada por jugada.",
      items: [
        { title: "Modo Press Box", desc: "8 tarjetas de puntos de conversación listas para producción por partido en vivo. Se actualizan solas durante la transmisión." },
        { title: "Asistente de entrevistas", desc: "Paquetes de preguntas para jugadores y entrenadores en EN, ES o bilingüe." },
        { title: "Asistente de narración", desc: "Guiones de apertura, medio tiempo y cierre en estilo TV o radio." },
      ],
      cta: "Mira el Modo Press Box en acción",
    },
    wim: {
      a: "Toca",
      b: "Por qué importa",
      c: "en cualquier partido",
      desc: "Cuentas de playoffs al instante, lo que está en juego en fantasy, el efecto en el mercado de tarjetas y lo único que debes ver después.",
      cta: "Empieza gratis",
    },
    footer: "© 2026 Gamly AI — Compañero deportivo con IA + Asistente de Press Box.",
  },
};
